import React, { FunctionComponent, useState } from 'react';
import { LuCopy, LuCopyCheck } from 'react-icons/lu';

interface ICopyToClipboardProps {
  text: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const CopyToClipboard: FunctionComponent<ICopyToClipboardProps> = ({ text, children, className = '', style }) => {
  const [hovered, setHovered] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  return (
    <>
      <div
        className={`${className} pointer`}
        style={style}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => {
          setHovered(false);
        }}
        onClick={handleCopy}
      >
        {children}
        <span
          style={{
            verticalAlign: 'bottom',
            marginLeft: 4,
            visibility: hovered || copied ? 'visible' : 'hidden',
            display: 'inline-flex',
            alignItems: 'center',
            transition: 'opacity 0.2s ease-in-out',
            opacity: hovered || copied ? 1 : 0,
            cursor: 'pointer',
          }}
          onClick={handleCopy}
        >
          {copied ? (
            <>
              <LuCopyCheck className="mr-1" />
              Copied!
            </>
          ) : (
            <LuCopy />
          )}
        </span>
      </div>
    </>
  );
};

export default CopyToClipboard;
